const de = {
  title: 'Stellengesuche',
  drawer: {
    titleCreate: 'Stellengesuch erstellen',
    titleEdit: 'Stellengesuch bearbeiten',
    approveDataPrivacy:
      'Mir ist bewusst, dass meine hier angegebenen Daten veröffentlicht und für alle registrierten Firmennutzer innerhalb des Dashboards einsehbar sind.',
    phone: 'Telefonnummer (freiwillig)'
  },
  dialogs: {
    deleteConfirm: 'Möchten Sie das Stellengesuch wirklich löschen?'
  },
  alerts: {
    deleteSuccess: 'Das Stellengesuch wurde gelöscht.',
    deleteFailed: 'Das Stellengesuch konnte nicht gelöscht werden.',
    updateSuccess: 'Das Stellengesuch wurde erfolgreich bearbeitet.',
    createSuccess: 'Das Stellengesuch wurde erfolgreich erstellt.',
    updateFailed: 'Das Stellengesuch konnte nicht bearbeitet werden.',
    createFailed: 'Das Stellengesuch konnte nicht erstellt werden.'
  },
  detailPage: {
    title: 'Stellengesuch',
    personalData: 'Persönliche Daten',
    moreData: 'Weitere Daten',
    contactNow: 'Jetzt kontaktieren'
  },
  tooltips: {
    charsLeft: 'Anzahl der übrigen Zeichen. Maximal 100'
  }
};

export default de;
export type StudentJobOffersTranslation = typeof de;
